/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.timesheets.programs'},
});

const ProgramsItem = () => (
  <RouteLinkItem
    route="midas/settings/timesheets/timesheet-programs"
    title={messages.title}
  />
);

export default ProgramsItem;
